import Guyn from 'guyn/guyn/json/guyn.json'

export const blocks = [
	[0, 1, 2, 9, 10, 11, 18, 19, 20],
	[3, 4, 5, 12, 13, 14, 21, 22, 23],
	[6, 7, 8, 15, 16, 17, 24, 25, 26],
	[27, 28, 29, 36, 37, 38, 45, 46, 47],
	[30, 31, 32, 39, 40, 41, 48, 49, 50],
	[33, 34, 35, 42, 43, 44, 51, 52, 53],
	[54, 55, 56, 63, 64, 65, 72, 73, 74],
	[57, 58, 59, 66, 67, 68, 75, 76, 77],
	[60, 61, 62, 69, 70, 71, 78, 79, 80],
]
export const grid = [
	0,
	1,
	2,
	9,
	10,
	11,
	18,
	19,
	20,
	3,
	4,
	5,
	12,
	13,
	14,
	21,
	22,
	23,
	6,
	7,
	8,
	15,
	16,
	17,
	24,
	25,
	26,
	27,
	28,
	29,
	36,
	37,
	38,
	45,
	46,
	47,
	30,
	31,
	32,
	39,
	40,
	41,
	48,
	49,
	50,
	33,
	34,
	35,
	42,
	43,
	44,
	51,
	52,
	53,
	54,
	55,
	56,
	63,
	64,
	65,
	72,
	73,
	74,
	57,
	58,
	59,
	66,
	67,
	68,
	75,
	76,
	77,
	60,
	61,
	62,
	69,
	70,
	71,
	78,
	79,
	80,
]

export const points = [
	{
		title: 'block-1-1',
		data: blocks[0],
	},
	{
		title: 'block-1-2',
		data: blocks[1],
	},
	{
		title: 'block-1-3',
		data: blocks[2],
	},
	{
		title: 'block-2-1',
		data: blocks[3],
	},
	{
		title: 'block-2-2',
		data: blocks[4],
	},
	{
		title: 'block-2-3',
		data: blocks[5],
	},
	{
		title: 'block-3-1',
		data: blocks[6],
	},
	{
		title: 'block-3-2',
		data: blocks[7],
	},
	{
		title: 'block-3-3',
		data: blocks[8],
	},
	{
		title: 'forwardslash',
		data: [0, 10, 20, 30, 40, 50, 60, 70, 80],
	},
	{
		title: 'backslash',
		data: [8, 16, 24, 32, 40, 48, 56, 64, 72],
	},
	{
		title: 'lines-horizontal-0',
		data: [0, 1, 2, 3, 4, 5, 6, 7, 8],
	},
	{
		title: 'lines-horizontal-1',
		data: [9, 10, 11, 12, 13, 14, 15, 16, 17],
	},
	{
		title: 'lines-horizontal-2',
		data: [18, 19, 20, 21, 22, 23, 24, 25, 26],
	},
	{
		title: 'lines-horizontal-3',
		data: [27, 28, 29, 30, 31, 32, 33, 34, 35],
	},
	{
		title: 'lines-horizontal-4',
		data: [36, 37, 38, 39, 40, 41, 42, 43, 44],
	},
	{
		title: 'lines-horizontal-5',
		data: [45, 46, 47, 48, 49, 50, 51, 52, 53],
	},
	{
		title: 'lines-horizontal-6',
		data: [54, 55, 56, 57, 58, 59, 60, 61, 62],
	},
	{
		title: 'lines-horizontal-7',
		data: [63, 64, 65, 66, 67, 68, 69, 70, 71],
	},
	{
		title: 'lines-horizontal-8',
		data: [72, 73, 74, 75, 76, 77, 78, 79, 80],
	},
	{
		title: 'lines-vertical-0',
		data: [0, 9, 18, 27, 36, 45, 54, 63, 72],
	},
	{
		title: 'lines-vertical-1',
		data: [1, 10, 19, 28, 37, 46, 55, 64, 73],
	},
	{
		title: 'lines-vertical-2',
		data: [2, 11, 20, 29, 38, 47, 56, 65, 74],
	},
	{
		title: 'lines-vertical-3',
		data: [3, 12, 21, 30, 39, 48, 57, 66, 75],
	},
	{
		title: 'lines-vertical-4',
		data: [4, 13, 22, 31, 40, 49, 58, 67, 76],
	},
	{
		title: 'lines-vertical-5',
		data: [5, 14, 23, 32, 41, 50, 59, 68, 77],
	},
	{
		title: 'lines-vertical-6',
		data: [6, 15, 24, 33, 42, 51, 60, 69, 78],
	},
	{
		title: 'lines-vertical-7',
		data: [7, 16, 25, 34, 43, 52, 61, 70, 79],
	},
	{
		title: 'lines-vertical-8',
		data: [8, 17, 26, 35, 44, 53, 62, 71, 80],
	},
]

export const shapes = [
	{ title: '1', data: [[1]], rotation: false },
	{ title: '2', data: [[1, 1]], rotation: 0 },
	{ title: '2', data: [[1], [1]], rotation: 90 },
	{ title: '4', data: [[1, 1], [1, 1]], rotation: false },
	{ title: '3', data: [[1], [1], [1]], rotation: 0 },
	{ title: '3', data: [[1, 1, 1]], rotation: 90 },
	{ title: 'I', data: [[1], [1], [1], [1]], rotation: 0 },
	{ title: 'I', data: [[1, 1, 1, 1]], rotation: 90 },
	{ title: 'L', data: [[1, 0], [1, 0], [1, 1]], rotation: 0 },
	{ title: 'L', data: [[1, 1, 1], [1, 0, 0]], rotation: 90 },
	{ title: 'L', data: [[1, 1], [0, 1], [0, 1]], rotation: 180 },
	{ title: 'L', data: [[0, 0, 1], [1, 1, 1]], rotation: 270 },
	{ title: 'J', data: [[0, 1], [0, 1], [1, 1]], rotation: 0 },
	{ title: 'J', data: [[1, 0, 0], [1, 1, 1]], rotation: 90 },
	{ title: 'J', data: [[1, 1], [1, 0], [1, 0]], rotation: 180 },
	{ title: 'J', data: [[1, 1, 1], [0, 0, 1]], rotation: 270 },
	{ title: 'S', data: [[1, 0], [1, 1], [0, 1]], rotation: 0 },
	{ title: 'S', data: [[0, 1, 1], [1, 1, 0]], rotation: 90 },
	{ title: 'S', data: [[1, 0], [1, 1], [0, 1]], rotation: 180 },
	{ title: 'S', data: [[0, 1, 1], [1, 1, 0]], rotation: 270 },
	{ title: 'Z', data: [[0, 1], [1, 1], [1, 0]], rotation: 0 },
	{ title: 'Z', data: [[1, 1, 0], [0, 1, 1]], rotation: 90 },
	{ title: 'Z', data: [[0, 1], [1, 1], [1, 0]], rotation: 180 },
	{ title: 'Z', data: [[1, 1, 0], [0, 1, 1]], rotation: 270 },
	{ title: 'T', data: [[1, 0], [1, 1], [1, 0]], rotation: 0 },
	{ title: 'T', data: [[1, 1, 1], [0, 1, 0]], rotation: 90 },
	{ title: 'T', data: [[0, 1], [1, 1], [0, 1]], rotation: 180 },
	{ title: 'T', data: [[0, 1, 0], [1, 1, 1]], rotation: 270 },
	{ title: '/', data: [[1, 0, 0], [0, 1, 0], [0, 0, 1]], rotation: 0 },
	{ title: '/', data: [[0, 0, 1], [0, 1, 0], [1, 0, 0]], rotation: 90 },
]

export const colors = {
	darkMode: {
		normal: Guyn.Black,
		normalHover: Guyn.Pink,
		normalHoverShadow: Guyn.Blue,
		active: Guyn.YellowLight,
		activeShadow: Guyn.OrangeDark,
		activeHover: Guyn.Blue,
		activeHoverShadow: Guyn.BlueDark,
		shapeNormal: Guyn.YellowDark,
		shapeHover: Guyn.White,
		shapeActive: 'lime',
		candrop: Guyn.YellowDark,
		candropShadow: Guyn.Brown,
		cantdrop: Guyn.PinkDark,
		cantdropShadow: `rgba(0,0,0,0)`,
		gridEven: Guyn.NightblueLight,
		gridUneven: Guyn.BlueDark,
	},
	lightMode: {
		normal: Guyn.White,
		normalHover: Guyn.Pink,
		normalHoverShadow: Guyn.Blue,
		active: Guyn.PinkDark,
		activeShadow: Guyn.RedDark,
		activeHover: Guyn.Blue,
		activeHoverShadow: Guyn.BlueDark,
		shapeNormal: Guyn.YellowDark,
		shapeHover: Guyn.Nightblue,
		shapeActive: 'lime',
		candrop: Guyn.Blue,
		candropShadow: Guyn.BlueDark,
		cantdrop: Guyn.PinkLight,
		cantdropShadow: `rgba(0,0,0,0)`,
		gridEven: Guyn.BeigeLight,
		gridUneven: Guyn.White,
	},
}
